import React from "react";
import { EditQuestionModalProps } from "../Interfaces/Interface"
const EditFunctionChecklist: React.FC<EditQuestionModalProps> = ({ question, onChange, onClose, onSave }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Edit Question</h3>
                <label>Function Area Name:</label>
                <textarea name="functionAreaName" value={question.functionAreaName || ""} onChange={onChange} />
                <label>Question Text:</label> 
                <textarea name="questionText" value={question.questionText || ""} onChange={onChange} />
                <label>Evidence Required:</label>
                <textarea name="evidenceRequired" value={question.evidenceRequired || ""} onChange={onChange} />
                <label>ISO Clause Reference:</label>
                <textarea name="isoClauseReference" value={question.isoClauseReference || ""} onChange={onChange} />
                <label>Annex A Control Reference:</label>
                <textarea name="annexAControlReference" value={question.annexAControlReference || ""} onChange={onChange} />
                <div className="buttons">
                    <button className="cancelbutton" onClick={onClose}>Cancel</button>
                    <button className="savebutton" onClick={onSave}>Save</button>
                </div>
            </div>
        </div>
    );
};
export default EditFunctionChecklist;